import { cn } from '@/lib/utils';
import Swal, { SweetAlertOptions } from 'sweetalert2';

// interface DecisionModalProps {
//     title?: string;
//     message?: string;
//     confirmButtonText?: string;
//     confirmButton?: string;
//     cancelButton?: string;
//     cancelButtonText?: string;
//     showCancelButton?: boolean;
// }

type DecisionModalProps = SweetAlertOptions & {
    message: string;
    confirmButtonClass?: string,
    cancelButtonClass?: string,
}

const defaultOptions: DecisionModalProps = {
    title: "Are you sure?",
    message: "Once deleted, you will not be able to recover this data!",
    confirmButtonText: "Delete",
    cancelButtonText: "Cancel",
    confirmButtonClass: "h-10 px-4 py-2 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-destructive text-destructive-foreground hover:bg-destructive/90 me-2",
    cancelButtonClass: "h-10 px-4 py-2 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-secondary text-secondary-foreground hover:bg-secondary text-white",
    showCancelButton: true,
}

export default async function DecisionModal(props: DecisionModalProps) {
    const {
        title,
        message,
        confirmButtonText,
        cancelButtonText,
        showCancelButton,
        confirmButtonClass,
        cancelButtonClass,
        ...rest
    } = { ...defaultOptions, ...props }
    return await Swal.fire({
        html: `
        <div class="flex flex-col items-center justify-center">
            <h5 class="montserrat font-bold mb-2">${title}</h5>
            <p class="m-0 montserrat text-sm">${message}</p>
        </div>
        `,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        buttonsStyling: false,
        showCancelButton: showCancelButton,
        customClass: {
            confirmButton: cn(defaultOptions.confirmButtonClass, confirmButtonClass),
            cancelButton: cn(defaultOptions.cancelButtonClass, cancelButtonClass),
        },
        ...rest
    })
}